import LoginButton from "components/auth/LoginButton";

export default function Login() {
  return (
    <div className="bg-white rounded-2xl shadow-xl p-6 lg:p-10 flex flex-col items-center w-full max-w-sm mx-4 lg:mx-0">
      <img
        src="logo192.png"
        alt="App Logo"
        className="w-16 h-16 lg:w-20 lg:h-20 mb-4 lg:mb-6 rounded-full border-2 border-blue-200 bg-gray-100 object-contain shadow"
      />
      <h1 className="text-xl lg:text-2xl font-bold mb-2 text-gray-800 text-center">
        Welcome to Eduvia
      </h1>
      <p className="text-gray-600 mb-6 lg:mb-8 text-center text-xs lg:text-sm max-w-xs">
        Sign in to access your personalized dashboard, manage your students, and
        explore all the features Eduvia has to offer.
      </p>
      <LoginButton />
    </div>
  );
}
